import { render, staticRenderFns } from "./DineIn.vue?vue&type=template&id=3d4140f8&lang=html"
import script from "./DineIn.vue?vue&type=script&lang=js"
export * from "./DineIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports